import { tv } from 'tailwind-variants'

export const buttonsVariants = tv({
  slots: {
    buttonsStyle: 'w-[60%] flex-1 self-end mb-mili',
    buttonSource: 'w-full hover:bg-secondary-light hover:cursor-default',
    buttonText: 'text-info-medium',
    buttonContainer: 'w-full pt-nano'
  },
  variants: {
    fullWidth: {
      true: {
        buttonsStyle: 'w-full'
      }
    },
    twoButtons: {
      true: {
        buttonsStyle: 'flex flex-row space-x-mili justify-between'
      }
    },
    threeButtons: {
      true: {
        buttonsStyle: 'flex-wrap flex-row space-y-nano'
      }
    },
    source: {
      CLIENT: {
        buttonSource: 'self-start bg-primary-xlight disabled:bg-secondary-xlight'
      },
      PRODUCT: {
        buttonSource: 'self-end bg-secondary-medium disabled:bg-secondary-medium',
        buttonText: 'text-white'
      }
    }
  }
})
